<template>
  <div v-loading.body="loading" style="width: 265px">
    <el-row>
      <el-col v-if="resData">
        <div
          v-for="list in resData.list"
          :key="list"
          style="page-break-after: always"
        >
          <el-row
            v-if="list.space || list.position"
            :span="24"
            style="
              margin-bottom: 0;
              padding: 10px;
              font-size: 24px;
              font-weight: 800;
            "
          >
            <el-col :span="18">{{ list.space }}&nbsp;</el-col>
            <el-col :span="6" style="text-align: right">{{
              list.position
            }}</el-col>
          </el-row>
          <!--<el-row :span="24" style="border-bottom: 1px solid">-->
          <!--  <el-col v-if="list.label_tag">-->
          <!--    服务项：{{ list.label_tag }}-->
          <!--  </el-col>-->
          <!--  <el-col v-if="list.label_remark">-->
          <!--    备注：{{ list.label_remark }}-->
          <!--  </el-col>-->
          <!--</el-row>-->
          <div style="margin-bottom: 0; width: 100%">
            <div style="font-size: 24px">{{ list.consignee }}</div>
            <div style="font-size: 16px; margin-top: 4px">
              收货地址：{{ list.address }}
            </div>
            <!--<div style="font-size: 16px;margin-top: 4px;">打印时间：{{resData.print_time}}</div>-->
          </div>
          <div style="border: 0.5px solid; width: 100%" />

          <div style="margin-bottom: 0; width: 100%">
            <img
              style="width: 265px; margin-top: 20px; margin-bottom: 10px"
              :src="
                'https://erp.yishouapp.com/barcode.php?text=' +
                list.wave_picking_no
              "
            />
          </div>
          <div style="text-align: center; font-weight: bold">
            快递公司:{{ list.shipping_company }}
          </div>
          <div
            style="
              border: 0.5px solid;
              width: 100%;
              font-size: 20px;
              padding-top: 0px;
            "
          />

          <!--商品信息-->
          <div
            v-for="goods in list.goods_info"
            :key="goods"
            style="margin-bottom: 0; width: 100%"
          >
            <div
              style="
                font-size: 24px;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: bold;
              "
            >
              <span style="font-weight: normal">{{ goods.goods_no }}</span>
              <span style="float: right">{{ goods.goods_location }}</span>
            </div>
            <div
              style="
                font-size: 22px;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: bold;
              "
            >
              <span
                style="
                  font-size: 12px;
                  font-weight: normal;
                  float: left;
                  border: black solid 1px;
                  border-radius: 100%;
                  padding: 0px 4px;
                "
                >{{ goods.no }}</span
              >
              <div v-for="sku in goods.sku" :key="sku">
                <div style="display: inline-block; float: right">
                  {{ sku }}
                </div>
                <div style="clear: both" />
              </div>
            </div>
            <div style="font-size: 16px; margin-top: 5px; margin-bottom: 5px">
              <span>{{ goods.goods_name }}</span>
            </div>
            <div style="border: 1px dotted; width: 100%" />
          </div>

          <div style="margin-bottom: 0; width: 100%">
            <div
              style="
                font-size: 24px;
                text-align: center;
                margin-top: 5px;
                margin-bottom: 5px;
              "
            >
              共{{ list.spu_num }}款，{{ list.sku_num }}件
            </div>
          </div>
          <div style="border: 2px dotted; width: 100%; margin-bottom: 20px" />

          <!--订单信息-->

          <div
            v-for="order in list.order_info"
            :key="order"
            style="margin-bottom: 0; width: 100%"
          >
            <div style="font-size: 16px; margin-top: 5px; margin-bottom: 5px">
              <span
                style="
                  font-size: 12px;
                  border: black solid 1px;
                  border-radius: 100%;
                  padding: 0px 4px;
                "
                >{{ order.order_no }}</span
              >
              <span v-if="type == 4">工单id：{{ order.work_id }}</span>
              <span v-if="type != 4">订单号：{{ order.order_sn }}</span>
              <div
                v-if="order.admin_note && type != 4"
                style="font-size: 18px; font-weight: bold"
              >
                客服备注：{{ order.admin_note }}
              </div>
              <div
                v-if="order.custom_note && type != 4"
                style="font-size: 18px; font-weight: bold"
              >
                用户备注：{{ order.custom_note }}
              </div>
              <div
                v-if="order.problem_name && type >= 4"
                style="font-size: 18px; font-weight: bold"
              >
                工单问题：{{ order.problem_name }}
              </div>
              <div
                v-if="order.problem_desc && type >= 4"
                style="font-size: 18px; font-weight: bold"
              >
                工单描述：{{ order.problem_desc }}
              </div>
            </div>
          </div>

          <div v-if="type == 4">
            <div style="border: 0.5px solid; width: 100%" />
            <div
              v-for="(blp_note, index) in list.blp_note"
              :key="index"
              style="margin-bottom: 0; width: 100%"
            >
              <div style="font-size: 16px; margin-top: 5px; margin-bottom: 5px">
                <span
                  style="
                    font-size: 12px;
                    border: black solid 1px;
                    border-radius: 100%;
                    padding: 0px 4px;
                  "
                  >{{ index + 1 }}</span
                >
                <span>工单id：{{ blp_note.work_id }}</span>
                <div style="font-size: 18px; font-weight: bold">
                  拆包备注：{{ blp_note.note }}
                </div>
              </div>
            </div>
          </div>

          <div style="border: 0.5px solid; width: 100%" />

          <!--<div style="margin-top: 5px;margin-bottom: 40px;width:100%;border: 0.5px solid;">-->
          <!--<span style="padding: 20px 20px 20px 20px;">亲亲，如商品有错/漏/破等质量问题，请您务必在3天内联系客服小姐姐哦，否则会影响您的售后服务呢！</span>-->
          <!--</div>-->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        delNum: 0,
        wave_picking_info_id: 0,
      },
      type: 1,
      msg: "",
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/getPrintWavePickingList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      wave_picking_id: this.$route.params.id,
      detailVisible: false,
      delVisible: false,
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      this.form.multipleSelection = this.$route.params.id;
      this.form.note = this.$route.params.note;
      if (this.$route.params.origin === "undefined") {
        this.form.origin = 1;
      } else {
        this.form.origin = this.$route.params.origin;
      }

      if (showLoading) {
        this.loading = true;
      }
      if (this.$route.query.type && this.$route.query.type >= 4) {
        this.type = this.$route.query.type;
        this.url = "/erp/AsWavePicking/getPrintWavePickingList";
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/PrintWavePicking.vue